import React from "react";

const FB_INSPIRED_BG =
  "https://customer-assets.emergentagent.com/job_codex-calculator/artifacts/ceu358s0_Soulfemmfbcover.jpg";

export const Hero = ({ onStart }) => {
  return (
    <section
      className="relative w-full overflow-hidden"
      data-testid="hero-section"
    >
      <div className="absolute inset-0">
        {/* Subtle starfield + warm gold ambience */}
        <div className="absolute inset-0" style={{
          background: "radial-gradient(ellipse at 50% 20%, rgba(212,175,55,0.18), transparent 55%), radial-gradient(ellipse at 80% 80%, rgba(74,14,78,0.35), transparent 60%), #0B0C10",
        }} />
        <img
          src={FB_INSPIRED_BG}
          alt=""
          className="w-full h-full object-cover opacity-25 mix-blend-screen"
          style={{ filter: "saturate(1.2) blur(14px)", objectPosition: "center 25%" }}
        />
        <div className="absolute inset-0 bg-[#0B0C10]/60" />
        <div className="absolute inset-0" style={{
          background: "radial-gradient(ellipse at 50% 35%, transparent 20%, rgba(11,12,16,0.7) 70%)",
        }} />
      </div>

      <div className="relative max-w-5xl mx-auto px-6 md:px-12 pt-24 md:pt-32 pb-16 md:pb-20 text-center">
        <div className="overline mb-8" data-testid="hero-overline">
          A Modern Mystic's Codex
        </div>
        <h1
          className="font-display text-5xl md:text-7xl lg:text-8xl leading-[1.05] tracking-tight"
          style={{ color: "var(--sf-ivory)" }}
          data-testid="hero-title"
        >
          Soul Femme{" "}
          <span className="italic" style={{ color: "var(--sf-leopard-gold)" }}>
            Codex
          </span>
        </h1>

        <div className="mt-12 max-w-2xl mx-auto space-y-6 text-left md:text-center">
          <p className="codex-emphasis">
            You are not becoming someone new.
            <br />
            You are recognising what has always been true.
          </p>
          <p className="codex-text">
            The Soul Femme Codex reveals how your energy is structured —
            <br className="hidden md:block" />
            how you think, feel, desire, and move through life.
          </p>
          <p className="codex-text italic">
            Not as theory. As pattern.
          </p>
          <p className="codex-text">
            A layered reflection of your design — across eras, dimensions,
            identity, emotion, magnetism, power, shadow, and direction.
          </p>
          <p className="codex-emphasis pt-2">
            You don't learn this.
            <br />
            You see it.
          </p>
        </div>

        <div className="mt-12 flex flex-wrap items-center justify-center gap-6">
          <button
            className="sf-btn-primary"
            onClick={onStart}
            data-testid="hero-start-button"
          >
            Begin Your Reading
          </button>
        </div>

        <div className="overline mt-20 opacity-70">
          A proprietary system rooted in ancient teachings &amp; intuitive transmission
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[var(--sf-leopard-gold)] to-transparent opacity-40" />
    </section>
  );
};

export default Hero;
